<template>
  <div class="card has-text-left">
    <div style="margin-top:10px;padding:10px; font-size:16px;">
      {{ insightName }}
      <!-- bouton pour afficher la liste des participants + la roue "insight" des résultats du groupe -->
      <span v-if="!this.$store.getters.button_renduRoue" style="float:right">
        <b-tooltip :label="$t('tooltip.graph')" position="is-left">
          <img
            src="~@/assets/img/icons/pie-chart.png"
            class="icon"
            @click="rendu('roue')"
          />
        </b-tooltip>
      </span>

      <span v-else style="float:right">
        <!-- bouton pour afficher la liste des participants en temps réel par profil dominant-->
        <b-tooltip :label="$t('tooltip.list')" position="is-left">
          <img
            src="~@/assets/img/icons/list.png"
            class="icon"
            @click="rendu('liste')"
          />
        </b-tooltip>
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    url_moderateur: {
      type: String,
      required: true,
    },
    insightName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["button_renduRoue", "button_renduListeTrigramme"]),
  },
  methods: {
    resultatsIndividual(url_moderateur) {
      this.$router.push({
        name: "resultats",
        params: { url_moderateur: url_moderateur, type: "resultatIndividual" },
      });
    },
    rendu(el) {
      this.$store.commit("INSIGHT_BUTTON_ROUE_LISTE", el);
    },
  },
};
</script>
<style scoped>
.icon {
  margin-top: 3px;
  width: 18px;
  height: 20px;
  cursor: pointer;
  margin-right: 10px;
}
</style>
